import { ContainerData } from './containerV2';

export type BlogPost = {
	Id: number;
	Title: string;
	Description: string;
	Order: number;
	UrlRewrite: string;
	StartTimeUtc: Date;
	Container: ContainerData | null;
	ImageUrl?: string;
};

export type FetchBlogPostsParams = {
	order: FetchBlogPostsOrder;
	overrideCache: boolean;
	pageIndex: number;
	pageSize: number;
	genericCategoryIds?: number[];
};

export enum FetchBlogPostsOrder {
	Latest = 0,
	Random = 1,
	LikeOrder = 2,
	RelevancyOrder = 3,
	MostCommented = 4,
	Journey = 5,
}
